export default {"src":"/_next/static/media/FSD-US-logo-blue-text.c60786f8.svg","height":611,"width":1500,"blurWidth":0,"blurHeight":0};